// TODO: Gerçek WhatsApp numarası ile değiştirilecek (placeholder)
export const WHATSAPP_NUMBER = "905555555555";

export function waLink(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export const WHATSAPP_INTENTS = {
  todayMenu: "Bugünün menüsünü WhatsApp'tan görmek istiyorum.",
  priceInfo: "330 TL günlük öğün hakkında bilgi almak istiyorum.",
  region: "Bölgeme teslimat var mı öğrenmek istiyorum.",
  firstOrder: "İlk siparişin nasıl çalıştığını öğrenmek istiyorum.",
  corporate: "Kurumsal yemek için bilgi almak istiyorum.",
  membership: "Üyelik hakkında bilgi almak istiyorum.",
  hero: "Merhaba, Meliha Sultan Ev Yemekleri hakkında bilgi almak istiyorum.",
  menuSummary: "Oluşturduğum menüyü WhatsApp üzerinden tamamlamak istiyorum.",
  exit: "Bugünün menüsünü ve teslimat detaylarını WhatsApp'tan almak istiyorum.",
};